import FormattedMessage from 'I18n/components/FormattedMessage';
import UIUAFeatureTable from 'ui-addon-upgrades/featureTable/FeatureTable';
import { SingleSkeletonLoader } from '../../components/SingleSkeletonLoader';
import { FeatureTableHeaderCellContent } from '../../components/feature-table/FeatureTableHeaderCellContent';
import { useFormattedFeatureTableBodyData } from '../../components/feature-table/useFormattedFeatureTableBodyData';
import FeatureTableFreePriceDisplay from '../../components/prices/FeatureTableFreePriceDisplay';
import { FreeToolsPurchaseMotion } from '../../containers/FreeToolsPurchaseMotion';
import { PriceByProductApiName } from '../../containers/PriceByProductApiName';
import { PurchaseMotionsByProductApiNameAndLocation } from '../../containers/PurchaseMotionsByProductApiNameAndLocation';
import { jsx as _jsx } from "react/jsx-runtime";
export const FreeToolsFeatureTable = ({
  isInApp = false
}) => {
  const formattedFeatureTableBodyData = useFormattedFeatureTableBodyData({
    productApiNames: ['hubspot-free', 'crm-suite-starter-bundle']
  });
  if (formattedFeatureTableBodyData.error) {
    return null;
  }
  if (formattedFeatureTableBodyData.loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 250,
      width: 1500
    });
  }
  if (formattedFeatureTableBodyData.data.sectionData.all.features.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIUAFeatureTable, {
    canViewNewSeats: true,
    headerData: {
      'hubspot-free': {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.customerPlatform.freeCard.title"
          }),
          Price: /*#__PURE__*/_jsx(FeatureTableFreePriceDisplay, {}),
          PurchaseMotion: /*#__PURE__*/_jsx(FreeToolsPurchaseMotion, {
            trackingSource: "free-card",
            sourceId: "free-tools-feature-table",
            isInApp: isInApp
          })
        })
      },
      'crm-suite-starter-bundle': {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.customerPlatform.starterCard.title"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: "crm-suite-starter-bundle"
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
            productApiName: "crm-suite-starter-bundle",
            location: "MERCH_CARD",
            displayCount: 1
          })
        })
      }
    },
    bodyData: formattedFeatureTableBodyData.data
  });
};